/**
 * 获取资源的收藏状态。
 *
 * @param {number} resourceId - 资源的 ID（例如，帖子、视频等）。
 * @param {number} resourceType - 资源的类型。
 * @returns {Promise<FavoriteStatus>} 返回包含收藏状态的 Promise。
 * @throws {Error} 如果请求失败。
 *
 * @remarks
 * 该函数发送请求以检查资源的收藏状态。响应包含资源是否被收藏以及被收藏的次数等信息。
 *
 * @example
 * ```typescript
 * const status = await fetchFavStatus(123, 1);
 * console.log(status.isFavorite); // true 或 false
 * console.log(status.count); // 收藏次数
 * ```
 */
export async function fetchFavStatus(
  resourceId: number,
  resourceType: number
): Promise<FavoriteStatus> {
  if (!useUserInfo().value.login) {
    return { isFavorite: false, count: 0 }
  }
  return http
    .get<{
      is_favorite: boolean
      count: number
    }>('/v1/favorite/is_favorite', {
      resource_id: resourceId,
      resource_type: resourceType
    })
    .then((res) => {
      return {
        isFavorite: res.data.is_favorite,
        count: res.data.count
      }
    })
    .catch(() => {
      return {
        isFavorite: false,
        count: 0
      }
    })
}
